<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="نرجسية">
<h1><span dir="rtl">نرجسية</span></h1>
<div class="section level2" id="narcissistic">
<h2>Narcissistic</h2>
<p><span dir="rtl">(افْتِتان المرء بذاته وإِعْجابه بها دون سواها)</span></p>
<p><span dir="rtl">أتعلم ما يغيظني كثيراً ؟</span></p>
<p><span dir="rtl">بعد أن ارى نفسي في المرآة ثم أنظر للبشر.. إنه يبدو كما لو أنه جحيمٌ بعد جنة.</span></p>
<br/>
<p style="text-align:center; direction:ltr">Do you know what’s making me crazy the most?</p>
<p style="text-align:center; direction:ltr">That after seeing my face in the mirror then I look to the humans, it seems hell after heaven.</p>
<br/><p style="text-align:center; direction:ltr">******</p>
<br/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?da9a0776